module.exports = __webpack_public_path__ + "img/9788960511224.6d7e9a44.jpg";